module.exports = __webpack_public_path__ + "img/riseup.png";